import axios from './ApiService'

export interface IPexelImageSearchResults {
	TotalResults: number,
	Page: number,
	PerPage: number,
	NextPage: string,
	Photos: IPexelsImage[]
}

export interface IPexelsImage {
	id: string,
	width: number,
	height: number,
	url: string,
	original: string,
	large: string,
	large2x: string,
	medium: string,
	small: string
	portrait: string,
	landscape: string,
	tiny: string,
	alt: string
}

export interface IPexelVideoSearchResults {
	TotalResults: number,
	Page: number,
	PerPage: number,
	NextPage: string,
	Videos: IPexelsVideo[]
}

export interface IPexelsVideo {
	id: string,
	width: number,
	height: number,
	url: string,
	image: string,
	duration: number,
	selectedFile: IPexelsVideoFile,
	files: IPexelsVideoFile[]
}

export interface IPexelsVideoFile {
	key: string,
	quality: string,
	fileType: string,
	width: number,
	height: number,
	link: string
}


export class PexelsService {

	async searchImages(searchQuery: string, page: number): Promise<IPexelImageSearchResults> {
		try {
			let result = await axios.get(`pexels/images/${searchQuery}/${page}`, {
				headers: {
					'Content-Type': 'application/json'
				}
			});

			let resultData = result.data;

			let photos: IPexelsImage[] = result.data.photos.map((p: any) => {
				return {
					id: p.id,
					width: p.width,
					height: p.height,
					url: p.url,
					original: p.source.original,
					large: p.source.large,
					large2x: p.source.large2x,
					medium: p.source.medium,
					small: p.source.small,
					portrait: p.source.portrait,
					landscape: p.source.landscape,
					tiny: p.source.tiny,
					alt: p.alt
				}
			});


			const resultSet: IPexelImageSearchResults = {
				TotalResults: resultData.totalResults,
				Page: resultData.page,
				PerPage: resultData.perPage,
				Photos: photos,
				NextPage: resultData.nextPage
			}

			return resultSet;
		}
		catch (error) {
			console.log(error);
			throw error
		}
	}

	async searchVideos(searchQuery: string, page: number): Promise<IPexelVideoSearchResults> {
		try {
			let result = await axios.get(`pexels/videos/${searchQuery}/${page}`, {
				headers: {
					'Content-Type': 'application/json'
				}
			});

			let resultData = result.data;			
			let videos: IPexelsVideo[] = result.data.videos.map((p: any) => {
				return {
					id: p.id,
					image: p.image,
					duration: p.duration,
					width: p.width,
					height: p.height,
					url: p.url,
					files: p.videoFiles.map((v: any) => {
						return {
							key: `${v.quality ? v.quality.toUpperCase() : ''} [${v.width}x${v.height}]`,
							quality: v.quality,
							fileType: v.fileType,
							width: v.width,
							height: v.height,
							link: v.link
						}
					})
				}
			});

			const resultSet: IPexelVideoSearchResults = {
				TotalResults: resultData.totalResults,
				Page: resultData.page,
				PerPage: resultData.perPage,
				Videos: videos,
				NextPage: resultData.nextPage
			}			
			return resultSet;
		}
		catch (error) {
			console.log(error);
			throw error
		}
	}
}